import { render, staticRenderFns } from "./PowerCodeExplainerLeft.vue?vue&type=template&id=223a4deb&scoped=true"
import script from "./PowerCodeExplainerLeft.vue?vue&type=script&lang=js"
export * from "./PowerCodeExplainerLeft.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "223a4deb",
  null
  
)

export default component.exports